var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-skeleton',{attrs:{"width":"40px","height":"57px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }